<script lang="ts">
  import { translation } from '$lib/locale/locale';
  import type { Tag } from '$lib/models/tag';
  import { CategoryType, categoryLink } from '$lib/utils/category';
  import { createEventDispatcher } from 'svelte';

  let { langHref, t } = translation();
  const dispatch = createEventDispatcher<{ change: void }>();

  export let categories: Tag[];
  export let type: CategoryType;
  export let visible: boolean = true;
  export let link = true;
  let lastSelectedTag: Tag | null = null;

  function select(tag: Tag, isParent = true) {
    if (isParent) {
      lastSelectedTag = tag;
    } else {
      lastSelectedTag = lastSelectedTag; // This is to trigger a reactivity update
    }
    if (tag.selected) {
      return;
    }
    tag.selected = true;
    categories = categories;
    dispatch('change');
  }

  function remove(tag: Tag) {
    if (!tag.selected) {
      return;
    }
    tag.selected = false;
    if (tag.children?.length) {
      tag.children.forEach((c) => (c.selected = false));
    }
    categories = categories;
    lastSelectedTag = lastSelectedTag;
    dispatch('change');
  }

  $: categories, (lastSelectedTag = lastSelectedTag);
</script>

<ul class:show={visible}>
  {#each categories as category (category.id)}
    <li class:selected={category.selected}>
      {#if link}
        <a
          class="filter"
          href={categoryLink(langHref, category, type)}
          on:click|preventDefault={() => {
            if (category.selected) {
              remove(category);
            } else {
              select(category);
            }
          }}
        >
          {category.name}
        </a>
      {:else}
        <button class="filter" on:click={() => select(category)}>{category.name}</button>
      {/if}
    </li>
  {/each}
</ul>

<style>
  ul {
    display: none;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  ul.show {
    display: flex;
  }

  ul li {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: white;
    border: 1px solid #f0f0f0;
    margin-right: 8px;
    margin-bottom: 8px;
    color: var(--text-secondary);
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  ul li .filter {
    display: flex;
    color: var(--black-coral);
    padding: 4px 8px;
    font-size: 1.167rem;
    font-weight: 400;
    white-space: nowrap;
    margin: 0;
  }

  ul li .filter:hover {
    text-decoration: none;
  }

  ul li:hover {
    border-color: var(--gainsboro);
    background-color: #f3f3f7;
    text-decoration: none;
  }

  ul li.selected {
    border-color: var(--charleston-grey);
  }

  ul li.selected .filter {
    color: var(--charleston-grey);
  }
</style>
